module.exports = __webpack_public_path__ + "img/3.fec2b5d5.png";